import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchAssignapp = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchAssignapp = async (assignappId) => {
    startLoading();
    const response = await apiGet(`/assignapps/${assignappId}`, "Error al obtener la asignación");
    setResponse(response);
    return response.data;
  };

  return { fetchAssignapp, data, error, loading };
};

export default useFetchAssignapp;
